import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./lib/content";
import HomePage from "./pages/HomePage";
import ProjectPage from "./pages/ProjectPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";

function App() {
  return (
    <div className="min-h-screen bg-ink-900 text-bone-50 grain">
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/project/:slug" element={<ProjectPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#171717",
            color: "#f5f1ea",
            border: "1px solid rgba(245,241,234,0.08)",
          },
        }}
      />
    </div>
  );
}

export default App;
